import { Button, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Modal, Select } from '@mui/material';
import  Axios  from 'axios';
import React, { useEffect, useState } from 'react';
import { Athlete } from '../atoms/athlete';
import { useAtomValue } from 'jotai';
import { athletesAtom } from '../atoms/athletesAtom';
import { Api } from '../providers/Api';

export class tath {
    id: string; bib: string; name: string; nat: string; matchedAthlete: Athlete}
class Props {
    useStartlist: (startlist : tath[]) => void;
}

const AddStartlist = (props: Props) => {
        const registerathletes = useAtomValue(athletesAtom);

    type tevent = {id: string, name: string, all: any}
    
    const [events, setEvents] = useState([] as tevent[]);
    const [event, setEvent] = useState(null as tevent);
    const [races, setRaces] = useState([] as tevent[]);
    const [race, setRace] = useState(null as tevent);
    const [athletes, setAthletes] = useState([] as tath[]);

    useEffect(()=>{
        let api = new Api();
        api.getEvents().then((data)=>{
            setEvents(data.map((x: any)=>{return {id: x.EventId, name: x.ShortDescription + " ("+x.Description+")", all: x} }));
        });
    },[]);

    useEffect(() => {
        if (event)
        {
            let api = new Api();
            api.getRaces(event.id).then((data)=>{
                setRaces(data.map((x: any)=>{return {id: x.RaceId, name: x.Description + " ("+x.StartTime+")", all: x} }));
            });
        }
    },[event]);

    useEffect(() => {
        if (race)
        {
            const isrelay = race.all.DisciplineId == "RL" || race.all.DisciplineId == "SR";
            let api = new Api();
            api.getStartlist(event.id, race.id).then((data)=>{
                setAthletes(data.Results.filter((x: any)=>{
                    return !isrelay || x.Leg > 0;
                }).map((x: any)=>{ 
                        const m = registerathletes.find(b=>b.lastName?.toUpperCase() + " " + b.firstName?.toUpperCase() == x.Name?.toUpperCase());
                        return { bib: x.Bib, 
                            id: x.IBUId,
                            name: x.Name, 
                            nat: x.Nat, 
                            matchedAthlete: m};
                }));
            });
        }
    },[race]);


    return  <Dialog
                open={true}
                disableEscapeKeyDown
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogTitle>
                    Add Startlist
                </DialogTitle>
                <DialogContent dividers>
                    <FormControl fullWidth>
                                <InputLabel shrink>Event</InputLabel>
                    <Select onChange={(ev) => {
                        const event = events.find(x=>x.id == ev.target.value);
                        setEvent(event);
                    }}>
                        {events.map((ev)=>{
                            return <MenuItem value={ev.id}>{ev.name}</MenuItem>
                        })}
                    </Select>
                    </FormControl>
                    <FormControl fullWidth>
                                <InputLabel shrink>Race</InputLabel>
                    <Select onChange={(ev) => {
                        const race = races.find(x=>x.id == ev.target.value);
                        setRace(race);
                    }}>
                        {races && races.map((ev)=>{
                            return <MenuItem value={ev.id}>{ev.name}</MenuItem>
                        })}
                    </Select>
                    </FormControl>

                    {athletes && athletes.length > 0 && <Button variant="contained" onClick={() => {
                        props.useStartlist(athletes);
                    }} >Use startlist</Button>}

                    <Grid container spacing={2}>
                        <Grid item xs={2}>Bib</Grid>
                        <Grid item xs={6}>Name</Grid>
                        <Grid item xs={2}>Nat</Grid>
                        <Grid item xs={2}>Matched</Grid>
                        {athletes && athletes.map((x) => {

                           
                        return <>
                        <Grid item xs={2}>{x.bib}</Grid>
                        <Grid item xs={6}>{x.name}</Grid>
                        <Grid item xs={2}>{x.nat}</Grid>
                        <Grid item xs={2}>{x.matchedAthlete != null ? "YES" : "NO"}</Grid>
                        </>;
                    })}
                    </Grid>
                

                </DialogContent>
                </Dialog>;
}

export default AddStartlist;